// extracted by mini-css-extract-plugin
module.exports = {"TableOfContents":"TableOfContents-module--TableOfContents--2rNAX","Heading":"TableOfContents-module--Heading--3HVm0"};